import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import animate from "animate.css";
import schema from "async-validator";
import dialog from "./utils/dialog";
import $scroll from "@utils/loading";
import cookie from "@utils/store/cookie";

import "@assets/iconfont/iconfont";
import "@assets/iconfont/iconfont.css";
import "@assets/js/media_750";
import "vue-ydui/dist/ydui.base.css";
import "@assets/css/base.css";
import "@assets/css/reset.css";
import "@assets/css/style.css";
import { isWeixin, parseQuery } from "@utils";

import '@/assets/font/font.css'



// import VueTimepicker from 'vue2-timepicker'
// // CSS
// import 'vue2-timepicker/dist/VueTimepicker.css'

// 在入口文件中（main.js），导入组件库
import vueHashCalendar from 'vue-hash-calendar'
// 引入组件CSS样式
import 'vue-hash-calendar/lib/vue-hash-calendar.css'
// 注册组件库
Vue.use(vueHashCalendar)




// import { createApp } from 'vue';
// import { ActionSheet } from 'vant';

// const app = createApp();
// app.use(ActionSheet);




// import { Field,Button } from 'vant';

import { Tab,Tabs,Col, Row,Button,Grid, GridItem,Image as VanImage,Card,Picker,Popup,Swipe, SwipeItem  } from 'vant';
Vue.use(Tab).use(Tabs);
Vue.use(Col);
Vue.use(Row);
Vue.use(Button);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(VanImage);
Vue.use(Card);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Swipe);
Vue.use(SwipeItem);


// import { Field,Button } from 'vant';
// Vue.use(Field);
// Vue.use(Button);
 
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import VuePreview from 'vue-preview'

// import Vconsole from 'vconsole'
// Vue.prototype.$vConsole = new Vconsole();


// import preview from 'vue-photo-preview'
// import 'vue-photo-preview/dist/skin.css'
// Vue.use(preview)

// Vue.use(VuePreview)

Vue.use(VuePreview, {
  mainClass: 'pswp--minimal--dark',
  barsSize: {top: 0, bottom: 0},
  captionEl: false,
  fullscreenEl: false,
  shareEl: false,
  bgOpacity: 0.85,
  tapToClose: true,
  tapToToggleControls: false
})




Vue.use(VideoPlayer)

// Vue.use(Tab).use(Tabs);
// Vue.use(Col);
// Vue.use(Row);
// Vue.use(Button);
// Vue.use(Grid);
// Vue.use(GridItem);
// Vue.use(VanImage);
// Vue.use(Card);



Vue.use(animate);
Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== "production";
Vue.prototype.$validator = function(rule) {
  return new schema(rule);
};
Vue.prototype.$scroll = $scroll;
Vue.prototype.$dialog = dialog;

const CACHE_KEY = "clear_0.0.1";

if (!cookie.has(CACHE_KEY)) {
  cookie.clearAll();
  cookie.set(CACHE_KEY, 1);
}

var urlSpread = parseQuery()["spread"];

if (urlSpread !== undefined) {
  var spread = cookie.get("spread");
  urlSpread = parseInt(urlSpread);
  if (!Number.isNaN(urlSpread) && spread !== urlSpread) {
    cookie.set("spread", urlSpread || 0);
  } else if (spread === 0 || typeof spread !== "number") {
    cookie.set("spread", urlSpread || 0);
  }
}

const _isWechat = isWeixin();
// const module = () => import("vconsole");
// module().then(Module => {
//   new Module.default();
// });

if (_isWechat) {
  const module = () => import("@libs/wechat");
  module().then(Module => {
    Module.default().then(() => Module.oAuth());
  });
}

const $vm = new Vue({
  router,
  store,
  render: h => h(App)
});

setTimeout(() => {
  $vm.$mount("#app");
}, 300);
